import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    profileType: null,
    groupId: null,
    groupName: null,
    athleteId: null,
    weekOfTheYearKey: null,
    workoutTemplateKey: null,
    taperData: null,
    programPhaseKey: null,
    programPhaseWeekIndex: null
}

const activeWorkoutPreviewSlice = createSlice({
    name: 'activeWorkoutPreview',
    initialState,
    reducers: {
        setActiveWorkoutPreviewState: (state, action) => {

            const { 
                profileType,
                groupId, 
                groupName,
                athleteId, 
                weekOfTheYearKey, 
                workoutTemplateKey, 
                taperData, 
                programPhaseKey, 
                programPhaseWeekIndex 
            } = action.payload

            state.profileType = profileType
            state.groupId = groupId
            state.groupName = groupName
            state.athleteId = athleteId
            state.weekOfTheYearKey = weekOfTheYearKey
            state.workoutTemplateKey = workoutTemplateKey
            state.taperData = taperData
            state.programPhaseKey = programPhaseKey
            state.programPhaseWeekIndex = programPhaseWeekIndex

        },
        resetActiveWorkoutPreviewState: () => initialState
    },
});

export const {
    setActiveWorkoutPreviewState,
    resetActiveWorkoutPreviewState
} = activeWorkoutPreviewSlice.actions;

export default activeWorkoutPreviewSlice.reducer;